import AuthContext from "context/AuthContext";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {useState, useContext, useRef, useEffect} from "react";
import {useTranslation} from "react-i18next";
import NavBreadcrum from "components/NavBreadcrum";

import TabResult from "./TabResult";

import navs from "../navs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axiApi from "../../../ApiCaller";
import {useParams} from "react-router-dom";
import Spinner from "components/loaders/spinner";

// TODO descargar excel con el resultado de las lineas con warnings

function FormImport() {
    const [_Tr] = useTranslation("routes");

    document.title = _Tr("labels.import");
    const bread = [
        {
            name: _Tr("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        {
            name: "Importaciones",
            url: "/asset-management/imports/",
            current: false,
        },
        {
            name: _Tr("labels.import"),
            current: true,
        },
    ];

    const importData = useRef(null);
    const [loading, setLoading] = useState(true);
    const {token} = useParams();

    useEffect(() => {
        if (token) {
            setLoading(true);
            axiApi
                .post(`/api/inventory/import/data/`, {token: token})
                .then((res) => {
                    // console.log(res.data);
                    importData.current = res.data;
                })
                .catch((err) => {
                    console.error("Error fetching import data:", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [token]);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="col-12 preview-canvas offcanvas-header mt-1">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="file-import" />
                </div>

                <div className="preview-title ps-4">
                    <h5>Inventario</h5>
                </div>
            </div>
            {loading ? (
                <div className="text-center py-5">
                    <Spinner />
                </div>
            ) : (
                <TabResult props={importData.current} />
            )}
        </>
    );
}

export default FormImport;
